<template>
  <v-container fluid class="pa-0" style="background-color: rgb(242, 242, 242)" fill-height>
    <v-row class="pa-0 d-flex align-center justify-center">
      <v-col cols="8">
        <v-row no-gutters class="justify-center align-center panel__main">
          <v-btn-toggle tile group mandatory v-model="userData.system" style="flex-direction: column; width: 125px;">
            <v-btn v-for="(item, idx) in sysBtns" :key="'sysBtn__' + idx" tile height="65"
                        :value="item.value" class="elevation-0 px-5 pt-2 font-weight-bold "  @click="go(item.value)">
              <svg-icon class="pb-1" :icon-class="item.value" />
              <br>
              {{ item.text }}
            </v-btn>
          </v-btn-toggle>
          <v-col style="width: calc(100% - 125px);">
            <template v-if="userData.system === 'HIP'">
              <v-row no-gutters>
                <v-col cols="12" lg="5">
                  <div class="panel__system d-flex align-center">
                    <div class="px-16">
                      <div class="system-title">
                        HiP
                      </div>
                      <div class="system-subtitle">
                        HD Hyundai Vietnam<br>
                        Internet<br>
                        Procurement
                        
                      </div>
                      <div class="d-flex">
                        <div class="system-charger d-flex align-center px-2 py-1" @click.stop="showChargerListPop = true">
                          <span class="mr-1">
                            Charger
                          </span>
                          <svg-icon class="pt-1 pb-1" icon-class="right-half-arrow" style="width: 32px;" />
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" lg="7" class="panel__login">
                  <v-row no-gutters>
                    <v-col>
                      <v-card-text class="pa-0">
                        <v-form>
                          <v-row no-gutters class="align-center">
                            <span class="label__input" />
                            <v-col cols="6">
                              <v-img :src="require(`@/assets/images/ci/HVS_color_en.jpg`)" contain />
                            </v-col>
                          </v-row>
                          <v-row no-gutters class="align-center pt-5">
                            <span class="label__input">
                              User ID
                            </span>
                            <v-col class="pl-3">
                              <v-text-field
                                v-model="userData.userId"
                                name="login"
                                class="user-info"
                                autocomplete="off"
                                placeholder="User ID"
                                type="text"
                                outlined
                                @keyup.enter="signIn()" />
                            </v-col>
                          </v-row>

                          <v-row no-gutters class="align-center pt-5">
                            <span class="label__input">
                              Password
                            </span>
                            <v-col class="pl-3">
                              <v-text-field
                                  v-model="userData.userPw"
                                  name="password"
                                  class="user-info"
                                  autocomplete="off"
                                  placeholder="Password"
                                  type="password"
                                  outlined
                                  @keyup.enter="signIn()" />
                            </v-col>
                          </v-row>

                          <v-row no-gutters class="pt-3">
                            <v-col class="d-flex justify-end">
                              <v-checkbox v-model="isSaveID" label="Save ID" on-icon="mdi-check-circle-outline" off-icon="mdi-checkbox-blank-circle-outline" />
                            </v-col>
                          </v-row>

                          <v-row no-gutters class="align-center pt-3">
                            <span class="label__input" />
                            <v-col class="pl-3">
                              <v-btn block x-large elevation="0" class="btn__login" @click="signIn()">{{ $t('login') }}</v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>
                    </v-col>
                  </v-row>

                  <v-row no-gutters class="pt-12">
                    <v-col>
                      <div class="d-flex justify-space-between align-center news-title pb-1">
                        <span class="news-main-title">
                          What's News
                        </span>

                        <span class="news-more" @click.stop="showNoticeListPop = true">
                          more
                          <v-icon>
                            mdi-chevron-right
                          </v-icon>
                        </span>
                      </div>

                      <div v-for="(item, idx) in newsList" :key="'news__' + idx" class="d-flex justify-space-between news-item py-2">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="news-item__title" @click.stop="clickNews(item)">
                              {{ item.title }}
                            </span>
                          </template>
                          <span>{{ item.title }}</span>
                        </v-tooltip>

                        <span class="news-item__date">
                          {{ item.stDte }}
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="timeout" color="error" top>
      {{ msg }}
    </v-snackbar>

    <LoginFail :showFail.sync="showFail" />
    <changePassPop :showChangePassPop.sync="showChangePassPop"  :userId = "userData.userId"/>
    <chargerListPop :showChargerListPop.sync="showChargerListPop" />
    <!-- <ieSettingPop :showIeSettingPop.sync="showIeSettingPop" /> -->
    <noticeListPop :showNoticeListPop.sync="showNoticeListPop" />
    <noticeContentsPop :showNoticeContentsPop.sync="showNoticeContentsPop" :bulletinNo="selectNotice.bulletinNo" :title="selectNotice.title" />

    <noticeContentsPop v-for="(item, idx) in newsList" :key="`noticeContentsPop_${idx}`"
      :showNoticeContentsPop="showCookieNews[`showPop${idx}`]"
      :bulletinNo="item.bulletinNo"
      :title="item.title"
      @closePop="showCookieNews[`showPop${idx}`] = false" />
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview'
import { fn_Login, fn_LoginSuccess } from '@/framework/login/login'
import { getLoginNoticeList, checkUserNew } from '@/api/common/login'
import localStore from '@/utils/localStore'
import Cookies from 'js-cookie'
import LoginFail from '@/layout/login/LoginFail'

import { getUserId, getComCode } from '@/utils/token'

import chargerListPop from '@/views/hip/Z/popup/chargerListPop'
import ieSettingPop from '@/views/hip/Z/popup/ieSettingPop'
import noticeListPop from '@/views/hip/Z/popup/noticeListPop'
import noticeContentsPop from '@/views/hip/Z/popup/noticeContentsPop'
import changePassPop from '@/views/hip/Z/popup/changePassPop'
import { Thumbmark } from '@thumbmarkjs/thumbmarkjs';

export default {
  name: 'login',
  mixins: [baseview],
  components: {
    LoginFail,
    chargerListPop,
    ieSettingPop,
    noticeListPop,
    noticeContentsPop,
    changePassPop
  },
  data() {
    return {
      showFail: false,
      userData: {
        userId: '',
        userPw: '',
        sysId: '',
        system: 'HIP'        
      },
      isSaveID: false,
      

      snackbar: false,
      msg: '',
      timeout: 2000,
      sysBtns: [
        { text: 'HVS', value: 'HVS' },
        { text: 'HiP', value: 'HIP' },
        { text: 'HiP-P', value: 'HIPP' },
        { text: 'HyCOT', value: 'HYCOT' }
      ],
      newsList: [],

      showChargerListPop: false,
      showIeSettingPop: false,
      showNoticeListPop: false,
      showNoticeContentsPop: false,
      showChangePassPop: false,
      selectNotice: {},
      
      deviceId: '',

      showCookieNews: {
        showPop0: false,
        showPop1: false,
        showPop2: false,
        showPop3: false,
        showPop4: false
      }
    }
  },
  created() {
    // 다국어 store 등록
    this.setLocale()

    this.$store.dispatch('user/ClearSession')
    this.$store.dispatch('system/ClearSession')

    const savedId = Cookies.get('hip_saveid')
    // console.log('savedId', savedId)
    if(savedId) {
      this.isSaveID = true
      this.userData.userId = savedId
    } else {
      this.isSaveID = false
    }
  },
  methods: {
    go(e){
      if(e == 'HVS')
        window.location.href = 'http://www.hd-hvs.com/';
      else if(e == 'HIPP')
        window.location.href = 'http://hipp.hd-hvs.com/';
      else if(e == 'HYCOT')
        window.location.href = 'http://hycot.hd-hvs.com/';
    },
    // 로그인
    signIn() {
      if(this.isSaveID) {
        let expDt = new Date()
        expDt.setTime(expDt.getTime() + 1000 * 3600 * 24 * 30); // 30 days
        Cookies.set('hip_saveid', this.userData.userId, { expires: expDt, path: '' })
      } else {
        Cookies.remove('hip_saveid')
      }

      this.$store.commit('system/SET_SYS_CD', this.userData.system)
      this.$store.commit('system/SET_SYS_ID', this.userData.system)

      if(this.$store.state.system.sysCd && this.$store.state.system.sysId) {
        this.userData.sysId = this.$store.state.system.sysId
        let param = {
          sysId: this.userData.system,
          userId : this.userData.userId,
          userThumbMark : this.deviceId
        }
        checkUserNew(param).then((res) => {

          //console.log("res :", res.USER_COOKIE)

          localStorage.setItem("deviceId", res.USER_COOKIE);
          //let expDt = new Date()
          //expDt.setTime(expDt.getTime() + 1000 * 3600 * 24 * 30); // 30 days
          //Cookies.set('user_cookie', res.USER_COOKIE, { expires: expDt, path: '' })

          if (res.CHKUSER === 'Y') {          
            this.showChangePassPop = true
            //console.log(this.showChangePassPop)
                        
          } else {
              fn_Login(this.userData).then((res) => {
              if (res.result) {
                 console.log('system : ', this.userData.system)
                // if (this.userData.system != 'MES') localStore.set('start-page', this.userData.system)
                //console.log('deviceID : ', this.deviceId)
                fn_LoginSuccess(this.userData.system)
              } else {
                if (res.msg !== 'loginFail') {
                  this.snackbar = true
                  this.msg = res.msg
                } else {
                  this.showFail = true
                }
              }
            })            
          }
        })
        
      } else {
        // 
      }
    },
    // 다국어 세팅
    setLocale() {
      if (!this.$localStore.get('locale')) {
        this.$localStore.set('locale', this.$vuetify.lang.current)
      } else {
        // if (this.$localStore.get('locale') == 'ko') {
        //   this.$vuetify.lang.current = 'ko'
        //   this.$i18n.locale = 'ko'
        // } else {
          this.$vuetify.lang.current = 'en'
          this.$i18n.locale = 'en'
        // }
      }
    },
    async getNewsList() {
      await getLoginNoticeList().then(res => {
        // console.log('getLoginNoticeListRes', res)

        this.newsList = res.list
      })
    },
    clickNews(item) {
      // console.log('clickNews item', item)

      this.selectNotice = item
      this.showNoticeContentsPop = true
    },
    openNoticeList() {
      if(this.newsList.length > 0) {
        const isSaved = Cookies.get(`hip_notice_${this.newsList[0].bulletinNo}`)
        
        if(!isSaved) {
          this.showCookieNews.showPop0 = true
        }
      }
      
      if(this.newsList.length > 1) {
        const isSaved = Cookies.get(`hip_notice_${this.newsList[1].bulletinNo}`)

        if(!isSaved) {
          this.showCookieNews.showPop1 = true
        }
      }

      if(this.newsList.length > 2) {
        const isSaved = Cookies.get(`hip_notice_${this.newsList[2].bulletinNo}`)

        if(!isSaved) {
          this.showCookieNews.showPop2 = true
        }
      }

      if(this.newsList.length > 3) {
        const isSaved = Cookies.get(`hip_notice_${this.newsList[3].bulletinNo}`)

        if(!isSaved) {
          this.showCookieNews.showPop3 = true
        }
      }

      if(this.newsList.length > 4) {
        const isSaved = Cookies.get(`hip_notice_${this.newsList[4].bulletinNo}`)

        if(!isSaved) {
          this.showCookieNews.showPop4 = true
        }
      }
    }
  },
  async mounted() {
    const tm = new Thumbmark()
    const result = await tm.get()
    this.deviceId = result.thumbmark
     
    await this.getNewsList()
    await this.openNoticeList()
  }
}
</script>

<style lang="scss" scoped>
.panel__main {
  background: #FFFFFF;
  mix-blend-mode: normal;
  box-shadow: 15px 15px 26px -4px rgba(78, 78, 78, 0.07);
  border-radius: 10px;
}

.label__input {
  color: #8E8E8E;
  width: 60px;
}

.user-info {
  border-radius: 6px;
}

.news-main-title {
  font-weight: bold;
  font-size: 18px;
  color: #555555;
}

.news-more {
  color: #777777;
}

.news-more:hover {
  color: #555555;
  font-weight: bold;
  cursor: pointer;
}

.news-title, .news-item {
  border-bottom: 1px solid #dddddd;
}

.news-item {
  color: #777777;
  font-size: 13px;
}

.news-item:hover {
  color: #555555;
  font-weight: bold;
  cursor: pointer;
}

.news-item__title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: calc(100% - 100px);
}

.news-item__date {
  width: 80px;
}

.panel__system {
  margin: -48px 0px -48px 0px;
  height: calc(100% + 96px);
  background: linear-gradient(180deg, #71BFE1 0%, #82C1DD 11.98%, #B9DDED 78.12%, #E1F6FF 100%);


  .system-title, .system-subtitle, .system-charger, .system-setting {
    color: #ffffff;
  }

  .system-title {
    font-size: 32px;
    font-weight: bold;
    padding-bottom: 8px;
  }

  .system-subtitle {
    padding-bottom: 280px;
  }

  .system-charger, .system-setting {
    font-weight: bold;
    font-size: 14px;
    border-radius: 6px;
  }

  .system-charger:hover, .system-setting:hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.1);
  }

  .system-charger {
    margin-right: 20px;
  }
}

.panel__login {
  padding: 120px 110px 60px 110px !important;
}

.btn__login {
  border-radius: 0px;
  background: linear-gradient(90deg, #82C1DD 0%, #A6D1E4 100%);
  color: #ffffff !important;
  font-weight: bold;
  font-size: 18px !important;
}

.v-btn-toggle {
  .v-btn {
    color: #999999;
    background: transparent;

    svg {
      stroke: #C9C9C9;
    }
  }

  $btnLoginColor: #2196F3;
  .v-btn:before {
    border-left: 6px solid #{$btnLoginColor};
;

  }

  .v-btn:hover:before {
    opacity: 0.3;
  }

  .v-btn--active:before {
    border-left: 6px solid #{$btnLoginColor};
    opacity: 1;
    background: transparent;
  }

  .v-btn--active {
    color: #{$btnLoginColor} !important;

    svg {
      stroke: #{$btnLoginColor};
    }
  }
}

::v-deep.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: #cccccc !important;
}

::v-deep.v-text-field--outlined.v-input--is-focused > .v-input__control > .v-input__slot fieldset {
  border-color: #A6D1E4;
}

</style>